import { OverviewComponent } from './overview/overview.component';
import { DiscussionComponent } from './discussion/discussion.component';
import { ProfileComponent } from './profile/profile.component';
import { CoriderRidesRequestsComponent } from './corider-rides-requests/corider-rides-requests.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthGuard } from '../auth/auth.guard';
import { RiderRidesRequestsComponent } from './rider-rides-requests/rider-rides-requests.component';
import { RiderRidesComponent } from './rider-rides/rider-rides.component';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'overview', component: OverviewComponent, canActivate: [AuthGuard] },
      { path: 'rides', component: RiderRidesComponent, canActivate: [AuthGuard] },
      {
        path: 'rides/:id/requests',
        component: CoriderRidesRequestsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'rides/requested',
        component: RiderRidesRequestsComponent,
        canActivate: [AuthGuard],
      },
      { path: ':id/discussion', component: DiscussionComponent, canActivate: [AuthGuard] },
      { path: 'profile', component: ProfileComponent, canActivate: [AuthGuard] },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
